<div class="customer-selector-compact">
  <!-- Field Label -->
  <label for="customer-search" class="field-label">
    Customer
    <span class="required-badge" *ngIf="required">Required</span>
  </label>

  <!-- Edit Mode: Read-only display with tag -->
  <div *ngIf="isEditMode && selectedCustomer" class="edit-mode-display mb-3">
    <p-tag
      [value]="customerDisplayName"
      severity="secondary"
      icon="pi pi-user"
      styleClass="text-base px-3 py-2 w-full justify-content-start"
    />
    <small class="text-gray-500 block mt-2">
      <i class="pi pi-lock mr-1"></i>
      Customer cannot be changed after order creation
    </small>
  </div>

  <!-- Create Mode: Autocomplete Field -->
  <div *ngIf="!isEditMode">
    <p-autoComplete
      inputId="customer-search"
      [formControl]="customerControl"
      [suggestions]="filteredCustomers"
      (completeMethod)="search($event)"
      (onSelect)="onSelect($event)"
      (onClear)="onClear()"
      (onFocus)="onCustomerFocus()"
      [disabled]="disabled"
      [showClear]="true"
      [minLength]="0"
      placeholder="Search by name, email, or ID..."
      styleClass="w-full "
      [class.p-invalid]="required && !selectedCustomer"
      [dropdown]="true"
      [forceSelection]="true"
      field="displayLabel"
      appendTo="body"
    >
      <ng-template let-customer pTemplate="item">
        <div class="customer-item-wrapper">
          <div class="customer-name-row">
            {{ customer.FirstName }} {{ customer.LastName }}
            <span class="customer-id">#{{ customer.Id }}</span>
          </div>
          <div class="customer-email-row">{{ customer.Email }}</div>
        </div>
      </ng-template>
    </p-autoComplete>

    <small class="text-gray-500 block mt-1">
      Click dropdown or type at least 2 characters to search
    </small>
  </div>

  <!-- Selected Customer Info Card -->
  <div *ngIf="selectedCustomer" class="customer-info-card">
    <!-- Header: Avatar + Name + ID + Badge -->
    <div class="card-header">
      <div class="customer-avatar">{{ getCustomerInitials() }}</div>
      <div class="customer-identity">
        <div class="customer-name">
          {{ selectedCustomer.FirstName }} {{ selectedCustomer.LastName }}
        </div>
        <div class="customer-id">#{{ selectedCustomer.Id }}</div>
      </div>
      <div
        class="customer-badge"
        *ngIf="
          selectedCustomer.CreatedUtc ||
          selectedCustomer.CreatedAt ||
          selectedCustomer.Created
        "
      >
        <i class="pi pi-calendar"></i>
        <span>
          Since
          {{
            formatDate(
              selectedCustomer.CreatedUtc ||
                selectedCustomer.CreatedAt ||
                selectedCustomer.Created
            )
          }}
        </span>
      </div>
    </div>

    <!-- Key Stats - Most Prominent -->
    <div class="stats-section" *ngIf="hasStatsInfo()">
      <div
        class="stat-card highlight"
        *ngIf="
          selectedCustomer.LifetimeValue !== undefined &&
          selectedCustomer.LifetimeValue !== null &&
          selectedCustomer.LifetimeValue > 0
        "
      >
        <div class="stat-icon">
          <i class="pi pi-dollar"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">
            {{ formatCurrency(selectedCustomer.LifetimeValue) }}
          </div>
          <div class="stat-label">Lifetime Value</div>
        </div>
      </div>
      <div
        class="stat-card"
        *ngIf="
          selectedCustomer.TotalOrders !== undefined &&
          selectedCustomer.TotalOrders !== null
        "
      >
        <div class="stat-icon">
          <i class="pi pi-shopping-cart"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ selectedCustomer.TotalOrders }}</div>
          <div class="stat-label">Total Orders</div>
        </div>
      </div>
    </div>

    <!-- Contact & Address - Compact -->
    <div class="details-section">
      <div class="detail-row email" *ngIf="selectedCustomer.Email">
        <i class="pi pi-envelope"></i>
        <span>{{ selectedCustomer.Email }}</span>
      </div>
      <div class="detail-row phone" *ngIf="selectedCustomer.PhoneNumber">
        <i class="pi pi-phone"></i>
        <span>{{ formatPhoneNumber(selectedCustomer.PhoneNumber) }}</span>
      </div>
      <div class="detail-row address" *ngIf="selectedCustomer.BillingStreet1">
        <i class="pi pi-map-marker"></i>
        <span
          >{{ selectedCustomer.BillingStreet1 }},
          {{ getLocationString() }}</span
        >
      </div>
      <div
        class="detail-row address"
        *ngIf="
          !selectedCustomer.BillingStreet1 &&
          (selectedCustomer.BillingCity || selectedCustomer.BillingState)
        "
      >
        <i class="pi pi-map-marker"></i>
        <span>{{ getLocationString() }}</span>
      </div>
      <div
        class="detail-row company"
        *ngIf="selectedCustomer.Company && selectedCustomer.Company.trim()"
      >
        <i class="pi pi-building"></i>
        <span>{{ selectedCustomer.Company }}</span>
      </div>
    </div>
  </div>
</div>
